/* UI-DESIGN: 2026-10-25 the hand ships as woff2 (144 KB ttf -> ~half), the
   largest font on the Home; the ttf stays beside its licence */
import reenieBeanie from "../../assets/lightbox/fonts/reeniebeanie.woff2";
import typedText from "../../assets/lightbox/fonts/cluetyped-text.woff2";
import typedSharp from "../../assets/lightbox/fonts/cluetyped-display-sharp-500.woff2";

/* UI-DESIGN: LB-30 the investigator's hand on the case files: Reenie
   Beanie (OFL, licence beside the file), picked by Taco 2026-10-03 over
   Caveat Brush and Permanent Marker. Loaded through the FontFace API
   because the scene draws it on canvas, where an @font-face rule alone
   never triggers the download. */
const FAMILY = "LB Hand";
const TYPED_TEXT = "LB Typed Text";
const TYPED_TITLE = "LB Typed Sharp";
const SCALE = 1.18; // Reenie Beanie sets small for its size

let loading: Promise<void> | null = null;
/* resolves once the hand can be drawn; callers redraw after it */
export const loadHand = (): Promise<void> => {
  if (loading) return loading;
  /* UI-DESIGN: Clue Typed on the case files too (Taco 2026-10-10: the 3D
     files should share the site's typed letters). Same FontFace route as the
     hand, since canvas text never triggers an @font-face download. */
  const faces = [
    new FontFace(FAMILY, `url(${reenieBeanie})`),
    new FontFace(TYPED_TEXT, `url(${typedText})`, { weight: "400" }),
    new FontFace(TYPED_TITLE, `url(${typedSharp})`, { weight: "500" }),
  ];
  loading = Promise.all(
    faces.map((face) =>
      face
        .load()
        .then((f) => {
          document.fonts.add(f);
        })
        .catch(() => undefined),
    ),
  ).then(() => undefined);
  return loading;
};

export const handFont = (px: number) => `${px * SCALE}px "${FAMILY}", "Marker Felt", cursive`;

/* the case files' printed furniture: titles in Clue Typed Display Sharp
   (LB-70, our own letters with square corners),
   small labels in Clue Typed Text. One real weight each, never faux bold. */
export const typedTitle = (px: number) => `500 ${px}px "${TYPED_TITLE}", "Courier New", monospace`;
export const typedLabel = (px: number) => `400 ${px}px "${TYPED_TEXT}", "Courier New", monospace`;
